/* Shared product card ("More from this brand" design). Markup: snippets/lpp-brand-card.liquid
   Cards are set up when the page loads and whenever new ones are added
   (collection filters, search, recently viewed), so nothing else needs to call this. */
(function () {
  if (window.lppBrandCard) return;

  var ORDER = ['1ml', '3ml', '5ml', '10ml'];
  var SPRAYS = { '1ml': 14, '3ml': 42, '5ml': 70, '10ml': 140 };
  var canHover = window.matchMedia('(hover: hover)').matches;

  /* ---------- Size picker on each card (tap a size again to turn it off) ---------- */
  function initCard(card) {
    if (card.dataset.fcReady) return;
    card.dataset.fcReady = '1';

    var dataEl = card.querySelector('[data-fc-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants.length) return;

    variants.sort(function (a, b) { return ORDER.indexOf(a.size) - ORDER.indexOf(b.size); });

    var sizesEl = card.querySelector('.fc__sizes');
    var priceEl = card.querySelector('.fc__price');
    var wasEl = card.querySelector('.fc__was');
    var perEl = card.querySelector('.fc__per');
    var addEl = card.querySelector('.fc__add');
    var overlay = card.querySelector('[data-fc-notes]');
    var mainImg = card.querySelector('.fc__img--main');
    if (!sizesEl || !priceEl || !addEl) return;

    var original = mainImg ? {
      src: mainImg.getAttribute('src'),
      srcset: mainImg.getAttribute('srcset'),
      sizes: mainImg.getAttribute('sizes')
    } : null;

    var defaultIndex = variants.findIndex(function (v) { return v.available; });
    if (defaultIndex === -1) defaultIndex = 0;
    var current = null;

    sizesEl.style.setProperty('--n', variants.length);
    variants.forEach(function (v, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fc__size';
      b.textContent = v.size;
      b.dataset.i = i;
      b.setAttribute('aria-pressed', 'false');
      if (!v.available) {
        b.disabled = true;
        b.setAttribute('aria-label', v.size + ', sold out');
      }
      sizesEl.appendChild(b);
    });

    function setButton(v, label) {
      addEl.dataset.variantTitle = v.title;
      addEl.dataset.productImage = v.image || '';
      addEl.dataset.inventoryQuantity = v.inv;
      if (v.available) {
        addEl.dataset.variantId = v.id;
        addEl.classList.remove('is-out');
        addEl.removeAttribute('aria-disabled');
        addEl.removeAttribute('tabindex');
        addEl.textContent = label;
      } else {
        // No variant id, so the cart can't add a sold-out size (keyboard included)
        addEl.dataset.variantId = '';
        addEl.classList.add('is-out');
        addEl.setAttribute('aria-disabled', 'true');
        addEl.setAttribute('tabindex', '-1');
        addEl.textContent = 'Sold out';
      }
    }

    function setPrice(v, showFrom) {
      priceEl.innerHTML = (showFrom ? '<span class="fc__from">From</span>' : '') + v.now;
      priceEl.classList.toggle('is-sale', !!v.sale);
      if (wasEl) {
        wasEl.hidden = !v.sale;
        wasEl.textContent = v.sale ? v.was : '';
      }
      if (perEl) perEl.textContent = SPRAYS[v.size] ? v.size + ' · ≈ ' + SPRAYS[v.size] + ' sprays' : '';
    }

    function markButtons(i) {
      sizesEl.querySelectorAll('.fc__size').forEach(function (b) {
        var on = i !== null && Number(b.dataset.i) === i;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
    }

    function restoreImage() {
      if (!mainImg || !original) return;
      if (original.srcset) mainImg.setAttribute('srcset', original.srcset);
      if (original.sizes) mainImg.setAttribute('sizes', original.sizes);
      mainImg.setAttribute('src', original.src);
    }

    function showDefault() {
      current = null;
      markButtons(null);
      var v = variants[defaultIndex];
      setPrice(v, true);
      setButton(v, 'Add ' + v.size + ' to bag');

      card.classList.remove('is-variant');
      if (overlay) overlay.setAttribute('tabindex', '0');
      restoreImage();
    }

    function select(i) {
      current = i;
      var v = variants[i];
      markButtons(i);
      setPrice(v, false);
      setButton(v, 'Add to bag');

      card.classList.add('is-variant');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-expanded', 'false');
        overlay.setAttribute('tabindex', '-1');
      }
      if (mainImg && v.big) {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.setAttribute('src', v.big);
      } else {
        restoreImage();
      }
    }

    sizesEl.addEventListener('click', function (e) {
      var b = e.target.closest('.fc__size');
      if (!b || b.disabled) return;
      var i = Number(b.dataset.i);
      if (current === i) showDefault();
      else select(i);
    });

    showDefault();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.lpp-bc[data-fc]').forEach(initCard);
  }

  /* ---------- Top-note badges: hover on desktop, tap to open on touch screens ---------- */
  function closeNotes(except) {
    document.querySelectorAll('.lpp-bc [data-fc-notes].is-open').forEach(function (o) {
      if (o === except) return;
      o.classList.remove('is-open');
      o.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleNotes(ov) {
    var open = !ov.classList.contains('is-open');
    closeNotes(ov);
    ov.classList.toggle('is-open', open);
    ov.setAttribute('aria-expanded', String(open));
  }

  document.addEventListener('click', function (e) {
    // Sold-out button: never let the cart handler see it
    var out = e.target.closest('.lpp-bc .fc__add.is-out');
    if (out) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var heart = e.target.closest('.lpp-bc .fc__wish');
    if (heart) {
      heart.classList.remove('is-pop');
      void heart.offsetWidth;
      heart.classList.add('is-pop');
    }

    var ov = e.target.closest('.lpp-bc [data-fc-notes]');
    if (!ov) {
      closeNotes(null);
      return;
    }
    if (e.target.closest('a.fc__ov-item') && ov.classList.contains('is-open')) return;
    if (canHover && !e.target.closest('a.fc__ov-item')) return;
    e.preventDefault();
    e.stopPropagation();
    toggleNotes(ov);
  }, true);

  document.addEventListener('keydown', function (e) {
    var ov = e.target.closest && e.target.closest('.lpp-bc [data-fc-notes]');
    if (!ov) return;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleNotes(ov); }
    if (e.key === 'Escape') { ov.classList.remove('is-open'); ov.setAttribute('aria-expanded', 'false'); }
  });

  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var ov = e.target.closest && e.target.closest('.lpp-bc [data-fc-notes]');
      if (ov) ov.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('mouseout', function (e) {
      var ov = e.target.closest && e.target.closest('.lpp-bc [data-fc-notes]');
      if (ov && !ov.contains(e.relatedTarget)) ov.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('animationend', function (e) {
    if (e.target.classList && e.target.classList.contains('fc__wish')) e.target.classList.remove('is-pop');
  });

  /* ---------- Set up cards now and whenever new ones appear ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  new MutationObserver(function (records) {
    for (var r = 0; r < records.length; r++) {
      var added = records[r].addedNodes;
      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (node.nodeType !== 1) continue;
        if (node.matches('.lpp-bc[data-fc]')) initCard(node);
        else if (node.querySelector('.lpp-bc[data-fc]')) initAll(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.lppBrandCard = { init: initAll };
})();
